// import { isEqual } from 'lodash';
import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createIraApplicationTransferType,
  updateIraApplicationTransferType,
} from '../store/actions/iraFunding/iraFundingActions';
import useApplicationUid from './useApplicationUid';

const useCustodianTransferTypeDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const custodianTransferTypeDispatch = ({
    data,
    params,
    defaultValues,
    onSuccess,
  }) => {
    const shouldSkip = isEqual(params, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data,
      params,
      onSuccess,
    };

    if (defaultValues?.transferType) {
      dispatch(
        updateIraApplicationTransferType({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createIraApplicationTransferType({
        ...requestData,
      }),
    );
  };

  return { custodianTransferTypeDispatch };
};

export default useCustodianTransferTypeDispatch;
